import { Info, UsersThree } from "@phosphor-icons/react";

import { formatNumber } from "common/helpers/utils";

import GroupOrEventHeading from "../GroupOrEventHeading";
import LeadsFound from "../LeadsFound";
import PreviewItemRow from "../PreviewItemRow";

import type { LinkedInGroup } from "../../../../types";

interface SelectedGroupProps {
  group: LinkedInGroup;
}

export default function SelectedGroup({ group }: SelectedGroupProps) {
  const { images, name, public: isPublic, member_count: memberCount } = group;

  const groupItems = [
    { icon: Info, label: "Group type", value: isPublic ? "Public" : "Private" },
    {
      icon: UsersThree,
      label: "People in group",
      value: formatNumber(memberCount),
    },
  ];

  return (
    <>
      <GroupOrEventHeading
        title={name}
        imageSrc={images.length ? images[0].url : undefined}
      />
      <div className="flex flex-col">
        {groupItems.map(({ icon: Icon, label, value }) => (
          <PreviewItemRow key={label} icon={Icon} label={label}>
            <div className="rounded-2xl px-3 py-1.5 bg-black-100 text-button-sm">
              {value}
            </div>
          </PreviewItemRow>
        ))}
      </div>
      <LeadsFound isLoading={false}>{memberCount}</LeadsFound>
    </>
  );
}
